import React from 'react';
import { Store } from '../../types/store.types';
import './StoreCard.scss';

interface StoreCardProps {
  store: Store;
  onClick: () => void;
}

const StoreCard: React.FC<StoreCardProps> = ({ store, onClick }) => {
  const getRoleBadgeColor = (roles: string[] = []) => {
    if (roles.includes('owner')) return 'badge--owner';
    if (roles.includes('admin')) return 'badge--admin';
    return 'badge--member';
  };

  const getMainRole = (roles: string[] = []) => {
    if (roles.includes('owner')) return 'Propriétaire';
    if (roles.includes('admin')) return 'Admin';
    return 'Membre';
  };

  return (
    <button type="button" className="store-card" onClick={onClick}>
      {store.logo_url ? (
        <img src={store.logo_url} alt="" className="store-card__logo" />
      ) : (
        <span className="store-card__mark">{store.name.charAt(0).toUpperCase()}</span>
      )}
      <span className="store-card__body">
        <strong>{store.name}</strong>
        {store.roles && store.roles.length > 0 && (
          <em className={`store-card__badge ${getRoleBadgeColor(store.roles)}`}>
            {getMainRole(store.roles)}
          </em>
        )}
      </span>
    </button>
  );
};

export default StoreCard;
